(function () {
  angular
    .module("akitabox.mobile.directives.pinValueList")
    .controller("PinValueInputController", PinValueInputController)
    .directive("abmPinValueInput", AbmPinValueInputDirective);

  /* @ngInject */
  function AbmPinValueInputDirective(
    $compile,
    $http,
    $log,
    $templateCache,
    $timeout
  ) {
    return {
      restrict: "E",
      controller: PinValueInputController,
      controllerAs: "vm",
      bindToController: true,
      link: postLink,
      scope: {
        ngModel: "=",
        ngChange: "&",
        field: "=",
        building: "=",
        floor: "=",
        pin: "=",
        isAsset: "=",
        isRoom: "=",
        fetchOpts: "&",
        readonlyLevel: "<?",
        readonlyRoom: "<?",
      },
    };

    function postLink($scope, $element, attrs, vm) {
      // Update placeholder
      vm.placeholder = "No " + vm.field.name.toLowerCase() + " specified";
      // Determine if field is readonly
      $timeout(function () {
        vm.readonly = vm.readonly || attrs.readonly;
      });
      // Get template based on data type
      var templateUrl = buildTemplateUrl(vm.field.data_type);
      if (!templateUrl) return;
      $http
        .get(templateUrl, { cache: $templateCache })
        .then(function (response) {
          if (response.status === 200) {
            $element.html(response.data);
            $compile($element.contents())($scope);
          } else {
            return $log.error(
              "<abm-pin-value-input> unable to retrieve '" + templateUrl + "'"
            );
          }
        });
    }

    /**
     * Build a template URL based on pin field type
     *
     * @param  {String} type    Pin field type
     * @return {String}         Template URL
     */
    function buildTemplateUrl(type) {
      if (!angular.isDefined(type))
        return $log.error("<abm-pin-value-input> type is required");
      if (type === "level") type = "floor";
      return (
        "app/mobile/directives/pin-value-list/templates/" +
        type.replace("_", "-") +
        ".html"
      );
    }
  }

  function PinValueInputController(
    // Angular
    $scope,
    $state,
    $window,
    // Services
    AssetService,
    FeatureFlagService,
    PinValueService,
    RoomService,
    ToastService
  ) {
    var self = this;

    var buildingId;

    // Attributes
    self.editing = false;
    self.value = null;
    self.originalValue = null;
    self.options = null;
    self.placeholder = "Enter " + self.field.name.toLowerCase();
    self.save = angular.isDefined(self.save) ? self.save : true;
    self.readonly = !self.field.is_editable;

    // Functions
    self.onChange = onChange;
    self.onCancel = onCancel;
    self.visitLink = visitLink;
    self.goToState = goToState;

    init();

    function init() {
      if (!self.save) self.editing = true;
      $scope.$watch("vm.editing", onEditingChange);

      buildingId = Object.prototype.hasOwnProperty.call(self.building, "_id")
        ? self.building._id
        : self.building;

      PinValueService.getByDataType(
        buildingId,
        self.field.data_type,
        self.ngModel
      )
        .then(function (value) {
          self.value = value;
          self.originalValue = angular.copy(self.value);
          return self.fetchOpts({ pinField: self.field });
        })
        .then(function (options) {
          self.options = options;
        })
        .catch(function (err) {
          if (err) ToastService.showError(err);
          self.options = [];
        });
    }

    /**
     * Handle editing state change
     *
     * @param  {Boolean} newValue   Currently editing
     * @param  {Boolean} oldValue   Was editing
     */
    function onEditingChange(newValue, oldValue) {
      if (newValue === oldValue) return;
      if (newValue) {
        // Hide the FAB
        $scope.$emit("fab:hide");
      } else {
        // Show the FAB
        $scope.$emit("fab:show");
      }
    }

    function onCancel() {
      self.value = angular.copy(self.originalValue);
    }

    function onChange(newValue) {
      // self.save defaults to true, so this will execute unless specifically told not to
      if (self.save) {
        // Update this value
        var dataType = self.field.data_type;
        var valueId = self.ngModel ? self.ngModel._id : null;

        var updateRequest;
        if (self.isRoom) {
          updateRequest = RoomService.updateValueByDataType(
            buildingId,
            dataType,
            self.pin,
            valueId,
            newValue
          );
        } else if (self.isAsset) {
          updateRequest = AssetService.updateValueByDataType(
            buildingId,
            dataType,
            self.pin,
            valueId,
            newValue
          );
        }
        updateRequest
          .then(function () {
            // Save was successful
            self.originalValue = angular.copy(newValue);
            if (angular.isFunction(self.ngChange)) {
              self.ngChange({ pinField: self.field, pinValue: newValue });
            }
          })
          .catch(function () {
            // revert
            self.onCancel();
          });

        // account for the case where we need to create an asset that doesn't yet have a Room or Floor
      } else if (
        angular.isFunction(self.ngChange) &&
        angular.isDefined(newValue)
      ) {
        self.ngChange({ pinField: self.field, pinValue: newValue });
      }
    }

    /**
     * Open a url link in a new tab
     *
     * @param  {String} url Url
     */
    function visitLink(url) {
      if (url && !url.match(/^(.*:\/\/)|(^\/).*/)) url = "//" + url;
      $window.open(url, "_blank");
    }

    function goToState(type) {
      var state;
      var params = { buildingId: self.building };

      switch (type) {
        case "room":
          state = "app.building.room.detail";
          params.roomId = self.value._id;
          break;
        default:
          return;
      }

      $state.go(state, params);
    }
  }
})();
